import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SearchCards from "components/TripCard/SearchCards";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router";

export default function PageSearchByCountry() {
    const search = useLocation().search;
    const code = new URLSearchParams(search).get("code");
    const country = new URLSearchParams(search).get("country");
    const openTrip = new URLSearchParams(search).get("openTrip");

    return (
        <div className="nc-PageHome relative overflow-hidden">
            <Helmet>
                <title>{country ? `Trip ${country} - GuideSantai` : "Trip Negara - GuideSantai"}</title>
            </Helmet>
            <BgGlassmorphism />
            <div className="container relative md:mb-24 lg:mb-32">
                <div className="relative">
                    <BackgroundSection />
                    <BgGlassmorphism />
                    <SearchCards country={{ code, country, openTrip, reset: true }} />
                </div>
            </div>
        </div>
    );
}